import React from 'react';
import { TourGuideImage } from '../TourGuideImage';
import image from '../images/image3.png';

export const Segment6 = () => (
    <div>
        <TourGuideImage src={image} footnote={"dreaming & the sound of the sea, 1949 nina leen"} />
    </div>
);
